import React, { useState } from 'react';
import moment from 'moment';

import BaseModal from '../base/modals/base-modal';
import dynamicInfo from '../../images/icons/dynamic-info.svg';
import MobileDayPicker from './mobile-day-picker';
import ChannelModal from './channel-modal';

import './create-story.scss';

const infoText =
  'A descriptive story name is highly recommended so you' +
  ' and also brands can identify and track performance by videos and stories.';

function CreateStory({ setPage, createNewLink }) {
  const [channel, setChannel] = useState(null);
  const [date, setDate] = useState(moment());
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [showChannel, setShowChannel] = useState(false);
  const [showInfo, setShowInfo] = useState(false);

  function buttonEnabled() {
    return channel && date && name;
  }

  function onButtonClick() {
    if (!buttonEnabled()) return;

    createNewLink(null, {
      channel,
      publication_date: date,
      name,
      edit_url: url,
    });
  }

  const channelPicker = showChannel ? (
    <ChannelModal channel={channel} setChannel={setChannel} setShowChannel={setShowChannel} />
  ) : null;

  const infoModal = showInfo ? (
    <BaseModal
      options={{
        displayTxt: infoText,
        cancel: {
          txt: 'Okay',
          callback: () => setShowInfo(false),
        },
      }}
    />
  ) : null;

  return (
    <div className="create-story">
      <div className="back-btn" onClick={() => setPage('modal')}>
        <span className="dropdown-icon" />
        Back to Search
      </div>
      <div className="label">Channel (Required)</div>
      <div className="input channel-dropdown" onClick={() => setShowChannel(true)}>
        <div className={`text ${channel ? 'full' : ''}`}>{channel || 'Select Channel'}</div>
        <div className="dropdown-icon"></div>
      </div>
      <div className="label">Publish Date (Required)</div>
      <div className="input date-dropdown">
        <MobileDayPicker date={date} setDate={setDate} />
        <div className="dropdown-icon"></div>
      </div>
      <div className="label" onClick={() => setShowInfo(true)}>
        Story/Video/Post (Required)
        <img className="info-icon" src={dynamicInfo} alt="info" />
      </div>
      <input
        className="input story-input"
        onChange={e => setName(e.target.value)}
        value={name}
        placeholder="e.g. Best Holiday Finds (Youtube 12/1/20)"
      />
      <div className="details">Choose a descriptive story name</div>
      <div className="label">Story/Video/Post URL (Optional)</div>
      <input
        className="input story-url-input"
        onChange={e => setUrl(e.target.value)}
        value={url}
        placeholder="Story/Video/Post URL"
      />
      <div className={`create-btn ${buttonEnabled() ? 'enabled' : ''}`} onClick={onButtonClick}>
        Create New Story & Link
      </div>
      {channelPicker}
      {infoModal}
    </div>
  );
}

export default CreateStory;
